"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jquery_1 = __importDefault(require("jquery"));
require("@SmartAdminBundle/scss/meeva/libs/_symfony-collection.scss");
const defaults = {
    selector: {
        collection: ".sf-collection",
        sortable: ".sf-sortable"
    },
    eventNamespace: "SymfonyCollection",
    animationTime: 1000,
    buttons: {
        add: {
            selector: ".sf-collection-add-item",
            prototype: '<button class="btn btn-success sf-collection-add-item" tabindex="-1"><i class="fa fa-fw fa-plus"></button>'
        },
        remove: {
            selector: ".sf-collection-remove-item",
            prototype: '<button class="btn btn-danger sf-collection-remove-item" tabindex="-1"><i class="fa fa-fw fa-trash"></button>'
        },
        sort: {
            selector: ".sf-collection-item-sortable-handle",
            prototype: '<div class="btn btn-primary sf-collection-item-sortable-handle pull-right" tabindex="-1"><i class="fa fa-fw fa-arrows-alt"></div>'
            // ui-sortable kann keine button, a oder input als handle verwenden
        }
    }
};
const SymfonyCollectionPlugin = function (app, config) {
    const settings = jquery_1.default.extend(true, {}, defaults, config);
    function createAddButtons(element) {
        element.before(settings.buttons.add.prototype);
        if (element.children().length > 0) {
            element.after(settings.buttons.add.prototype);
        }
    }
    function createOrUpdateRemoveButtons(element) {
        element.children().each((index, child) => {
            let button = (0, jquery_1.default)(child).find(settings.buttons.remove.selector);
            if (!button.length) {
                button = (0, jquery_1.default)(settings.buttons.remove.prototype).appendTo(child);
            }
            if (element.data("min-count")) {
                button.prop("disabled", element.children().length <= element.data("min-count"));
            }
        });
    }
    function createSortButtons(element) {
        element.children().each((index, child) => {
            if ((0, jquery_1.default)(child).find(settings.buttons.sort.selector).length > 0) {
                return;
            }
            (0, jquery_1.default)(child).append(settings.buttons.sort.prototype);
        });
    }
    function removeItem(container, item) {
        const entry = container.children().filter((index, element) => jquery_1.default.contains(element, item));
        (0, jquery_1.default)(entry).slideUp(() => {
            (0, jquery_1.default)(entry).remove();
            container.trigger(jquery_1.default.Event("sf-collection", { action: "removed", element: entry }));
        });
    }
    function addItem(container) {
        const itemIndex = container.data("index");
        const prototype = (0, jquery_1.default)(container).data("prototype").replace(/__name__/g, itemIndex);
        container.data("index", itemIndex + 1);
        if (container.children().length === 0) {
            container.after(settings.buttons.add.prototype);
        }
        const element = (0, jquery_1.default)(prototype).appendTo(container);
        container.trigger(jquery_1.default.Event("sf-collection", { action: "added", element }));
        if (settings.animationTime && settings.animationTime > 0) {
            const lastChildOffset = (0, jquery_1.default)(container).children().last().offset();
            if (lastChildOffset) {
                (0, jquery_1.default)([document.documentElement, document.body]).animate({
                    scrollTop: lastChildOffset.top
                }, settings.animationTime);
            }
        }
    }
    function updateCollectionEntryIndex(collection) {
        const prototypePrefix = collection.data("prototype-prefix").replace(/\[[^\]]+]$/, "");
        const collectionItems = collection.find("> :not(.btn)");
        const prefixExpression = new RegExp(`${prototypePrefix.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&")}\\[\\d+\\]`);
        collectionItems.each(function (index) {
            (0, jquery_1.default)(this).find(":input").each(function () {
                const name = (0, jquery_1.default)(this).attr("name");
                if (name) {
                    const newName = name.replace(prefixExpression, `${prototypePrefix}[${index}]`);
                    (0, jquery_1.default)(this).attr("name", newName);
                }
            });
        });
    }
    function setupSortable(element) {
        element.sortable({
            axis: "y",
            items: "> :not(.btn)",
            handle: settings.buttons.sort.selector,
            opacity: 0.5
        }).on(`sortupdate.${settings.eventNamespace}`, () => {
            // Standard verhalten kann mit $('.sf-collection').off('sortupdate.SymfonyCollection') deaktiviert werden
            updateCollectionEntryIndex(element);
        });
    }
    function setupListeners(element) {
        element.on(`click.${settings.eventNamespace}`, settings.buttons.remove.selector, (e) => {
            removeItem(element, e.currentTarget);
            return false;
        });
        element.parent().on(`click.${settings.eventNamespace}`, settings.buttons.add.selector, (e) => {
            e.stopPropagation();
            addItem(element);
            return false;
        });
    }
    this.init = () => {
        this.refresh(document.body);
    };
    this.refresh = (node) => {
        (0, jquery_1.default)(node).find(settings.selector.collection).each(function () {
            const element = (0, jquery_1.default)(this);
            if (element.data("sf-collection")) {
                return;
            }
            if (element.is(settings.selector.sortable)) {
                element.data("allow-sort", true);
            }
            element.data("sf-collection", true);
            if (element.data("allow-add")) {
                createAddButtons(element);
            }
            if (element.data("allow-delete")) {
                createOrUpdateRemoveButtons(element);
            }
            if (element.data("allow-sort")) {
                createSortButtons(element);
                setupSortable(element);
            }
            setupListeners(element);
            element.data("index", element.children().length);
            // element.on('sf-collection', (e) => {
            element.on("sf-collection", (_event) => {
                const e = _event;
                createOrUpdateRemoveButtons(element);
                if (element.data("allow-sort")) {
                    createSortButtons(element);
                }
                if (element.children().length === 0) {
                    element.next(".sf-collection-add-item").remove();
                }
                if (e.action === "added") {
                    (0, jquery_1.default)(e.element).find("input[data-default-value], select[data-default-value], textarea[data-default-value]").each((index, input) => {
                        (0, jquery_1.default)(input).val((0, jquery_1.default)(input).data("default-value"));
                    });
                }
                app.partialInit(element.get(0));
            });
        });
    };
    this.destroy = () => {
        (0, jquery_1.default)(settings.selector)
            .off(`click.${settings.eventNamespace}`)
            .find(settings.buttons.remove.selector).remove()
            .end()
            .find(settings.buttons.sort.selector)
            .remove()
            .end()
            .siblings(settings.buttons.add.selector)
            .remove();
    };
    return this;
};
exports.default = SymfonyCollectionPlugin;
